module.exports = __webpack_public_path__ + "img/invest_plan_3.aec7fc9e.svg";